module.exports = __webpack_public_path__ + "static/media/reports-icon.e0b80e61.svg";